import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
//import Backend from 'i18next-http-backend'; //if translations are loaded from backend dynamically

// Load translation files from the frontend
import en from '../locales/en.json'; // Adjust path based on your folder structure

i18n
  .use(LanguageDetector) // Automatically detects the user's language
  .use(initReactI18next) // Pass the i18n instance to react-i18next
  .init({
    resources: {
      en: {
        translation: en, // Load the English translations statically
      },
      // Add more languages here if needed
    },
    fallbackLng: 'en', // Default languages
    debug: false, // Enable console logs for debugging
    interpolation: {
      escapeValue: false, // React already prevents XSS
    },
  });

export default i18n;
